import { FilterProvider } from '@/components';
import NotFound from '@/components/NotFound/NotFound';
import { RoutingEndpoints } from '@/constants';
import { RouteEntry } from '@/core';
import { DashboardPage } from '@/modules/Dashboard';
import DashboardAuthCallback from '@/modules/home/pages/DashboardAuthCallback';

export const routerConfiguration: RouteEntry[] = [
  {
    path: RoutingEndpoints.home(),
    component: () => <DashboardAuthCallback />,
  },
  {
    path: RoutingEndpoints.dashboard(),
    component: () => (
      <FilterProvider>
        <DashboardPage />
      </FilterProvider>
    ),
    withAuth: true,
  },
  {
    path: RoutingEndpoints.notFound(),
    component: NotFound,
  },
];
